import { default as indexPDiogDu7rAMeta } from "/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/pages/about/index.vue?macro=true";
import { default as indexd2WsO9wb0aMeta } from "/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/pages/career/index.vue?macro=true";
import { default as indexyY7w9AbizHMeta } from "/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/pages/contacts/index.vue?macro=true";
import { default as indexklZxsK4M9lMeta } from "/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/pages/documents/index.vue?macro=true";
import { default as indexN7FZ8CEgsoMeta } from "/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/pages/index.vue?macro=true";
import { default as indexYYxB9dRdx5Meta } from "/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/pages/news/index.vue?macro=true";
import { default as _91slug_936LOLvYI4AHMeta } from "/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/pages/services/[slug].vue?macro=true";
export default [
  {
    name: "about___en",
    path: "/en/about",
    component: () => import("/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/pages/about/index.vue")
  },
  {
    name: "about___ru",
    path: "/about",
    component: () => import("/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/pages/about/index.vue")
  },
  {
    name: "career___en",
    path: "/en/career",
    component: () => import("/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/pages/career/index.vue")
  },
  {
    name: "career___ru",
    path: "/career",
    component: () => import("/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/pages/career/index.vue")
  },
  {
    name: "contacts___en",
    path: "/en/contacts",
    component: () => import("/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/pages/contacts/index.vue")
  },
  {
    name: "contacts___ru",
    path: "/contacts",
    component: () => import("/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/pages/contacts/index.vue")
  },
  {
    name: "documents___en",
    path: "/en/documents",
    component: () => import("/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/pages/documents/index.vue")
  },
  {
    name: "documents___ru",
    path: "/documents",
    component: () => import("/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/pages/documents/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/",
    component: () => import("/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/pages/index.vue")
  },
  {
    name: "news___en",
    path: "/en/news",
    component: () => import("/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/pages/news/index.vue")
  },
  {
    name: "news___ru",
    path: "/news",
    component: () => import("/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/pages/news/index.vue")
  },
  {
    name: "services-slug___en",
    path: "/en/services/:slug()",
    component: () => import("/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/pages/services/[slug].vue")
  },
  {
    name: "services-slug___ru",
    path: "/services/:slug()",
    component: () => import("/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/pages/services/[slug].vue")
  }
]